import { useEffect, useState } from "react";
import Loader from "../LoadingPage/DefaultLoader";
import { signOut } from "../../Services/auth";

function Logout() {
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;
    const doLogout = async () => {
      try {
        await signOut();
        // After clearing tokens, send user to login
        window.location.href = "/login";
      } catch (e) {
        if (!isMounted) return;
        setError("Something went wrong while logging out. Please try again.");
        // Fallback: still force local redirect after a delay
        setTimeout(() => {
          window.location.href = "/login";
        }, 1500);
      }
    };
    doLogout();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", flexDirection: "column" }}>
      <Loader />
      {error && (
        <div style={{ color: "red", marginTop: 16 }}>{error}</div>
      )}
    </div>
  );
}

export default Logout;
